import { render, staticRenderFns } from "./routerViews.vue?vue&type=template&id=f106fb16&"
import script from "./routerViews.vue?vue&type=script&lang=js&"
export * from "./routerViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports